<template>
    <div>
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-x>
            <template v-slot:activator="{ on, attrs }">
                <v-badge
                    :value="hasFilters"
                    color="#41916b"
                    style="width:100%"
                    overlap 
                >
                    <template v-slot:badge>
                        <v-icon
                            small
                            color="white"  
                            style="cursor: pointer"
                            @click.stop="clearFields()"
                        >
                            mdi-close
                        </v-icon>
                    </template>

                    <v-btn
                    class="rounded-lg"
                    elevation="1"
                    block
                    color="#aab5b0"
                    v-bind="attrs"
                    v-on="on"
                    >
                    <v-icon class="mr-2" color="#FFFFFF">mdi-filter</v-icon>
                    <span class="textBtn">FILTRO</span>
                    </v-btn>
                </v-badge>
            </template>

            <v-card  class="rounded-lg">
                <v-list dense class="text-center w-full text-xs font-medium"> 
                <span>Selecione os Filtros</span>
                </v-list>

            <div class="overflow-y-auto gap-0 flex-1">
                <v-list>
                <v-list-item>
                    <v-text-field
                    color="#086318" 
                    label="Número do Prontuário" 
                    class="rounded-lg"
                    hide-details
                    type="number"
                    outlined 
                    v-model="donorSearch.medical_records"
                    dense>
                    </v-text-field>
                </v-list-item>
                <v-list-item>
                    <v-text-field
                    color="#086318" 
                    label="Nome" 
                    placeholder="Nome completo" 
                    class="rounded-lg"
                    outlined 
                    v-model="donorSearch.name"
                    hide-details
                    dense></v-text-field>
                </v-list-item>
                <v-list-item>
                    <v-text-field
                        color="#086318" 
                        label="CPF" 
                        placeholder="CPF" 
                        outlined 
                        class="rounded-lg"
                        v-model="donorSearch.cpf"
                        maxlength="14" 
                        hide-details
                        v-mask="'###########'"
                        dense>
                    </v-text-field>
                </v-list-item>
                <v-list-item v-if="showPCRandMEPatients && this.profile != 'plantonista_opc'">
                    <v-select 
                        :items="kind_of_donors"
                        label="Situação do Paciente"
                        class="rounded-lg"
                        color="#086318" 
                        v-model="donorSearch.kind_of_donor"
                        item-value="id"
                        item-text="name"  
                        hide-details
                        dense 
                        outlined>
                    </v-select>
                </v-list-item>
                <v-list-item v-if="showAllUnities">
                    <v-autocomplete 
                    :items="hospitals"
                    label="Hospital Notificante"
                    class="rounded-lg"
                    color="#086318" 
                    v-model="donorSearch.unity"
                    item-value="id"
                    item-text="hospital"  
                    dense 
                    hide-details
                    outlined>
                    </v-autocomplete>
                </v-list-item>    
                <v-list-item v-if="showAllUnities">
                    <v-select 
                    :items="opos"
                    label="OPO Referência"
                    class="rounded-lg"
                    color="#086318" 
                    v-model="donorSearch.opo"
                    item-value="id"
                    item-text="description"  
                    dense 
                    hide-details
                    outlined>
                    </v-select>
                </v-list-item>    
                <v-list-item v-if="showAllUnities">
                    <v-select 
                    :items="opcs"
                    label="OPC Referência"
                    class="rounded-lg"
                    color="#086318" 
                    v-model="donorSearch.opc"
                    item-value="id"
                    item-text="description"  
                    dense 
                    hide-details
                    outlined>
                    </v-select>
                </v-list-item>  
                <v-list-item v-if="this.currentUser.profile != 'tec_banco_olhos'">
                    <v-select 
                        :items="donor_status"
                        label="Status"
                        class="rounded-lg"
                        hide-details
                        color="#086318" 
                        v-model="donorSearch.status"
                        item-value="id"
                        item-text="name"  
                        dense 
                        outlined>
                    </v-select>
                </v-list-item>

                <v-list-item >
                    <v-text-field 
                        label="RGCT"
                        class="rounded-lg"
                        hide-details
                        color="#086318" 
                        v-model="donorSearch.rgct"
                        v-mask="'######-####'"
                        dense 
                        outlined>
                    </v-text-field>
                </v-list-item>

                </v-list>
            </div>
                
                <v-card-actions class="d-flex justify-space-between">
                <v-btn
                    small
                    color="#aab5b0"
                    class="rounded-lg"
                    :loading="loadingTrashButton" 
                    @click="clearFields(), loadingTrashButton = true;"
                    dark
                >
                    {{$t('buttons.clean_up')}}
                </v-btn>
                <v-btn
                    class="rounded-lg"
                    color="#41916b"
                    small
                    dark
                    :loading="loadingBTN"
                    @click="search(), loadingBTN = true, loading = true"
                >
                    <v-icon color="#FFFFFF">mdi-magnify</v-icon>
                    {{$t('buttons.search')}}
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-menu>
    </div>
</template>
<script> 
import currentUser from "@/utils/currentUser";
import FormFieldsService from '@/service/FormFieldsService';
import { profileSlug } from "@/helpers/profileSlug";
    export default {
        data() {
            return {
                loadingBTN: false,
                loadingTrashButton: false,
                menu: false,
                donorSearch: {},
                donor_status: [],
                kind_of_donors: [],
                opos: [],
                opcs: [],
                hospitals: []
            }
        }, 

        async mounted() {
            this.donor_status = await FormFieldsService.getDonorStatus();
            this.kind_of_donors = await FormFieldsService.getKindOfDonor();
            this.opos = await FormFieldsService.getOpos();
            this.opcs = await FormFieldsService.getOpcs();
            this.hospitals = await FormFieldsService.getUnities();

            const savedSearch = sessionStorage.getItem('donorSearchFilter');
            if(savedSearch) {
                this.donorSearch = JSON.parse(savedSearch);
 
                this.search();
            }
        },

       computed: {
            currentUser(){
                return currentUser.getUserData()
            },

            isADM(){ 
                return [
                    'admin',
                    'diretor',
                    'plantonista_cet_coset',
                    'sesab_coset',
                    'tec_central', 
                ].includes(this.profile);
            },

            showAllUnities() {
                return this.currentUser.abilities?.includes('list_all_unities')
            },

            showPCRandMEPatients() {
                const abilities = this.currentUser.abilities || []

                return abilities.includes('list_all_unities') &&
                        abilities.includes('list_pcr_donor_data')
            },

            profile() {
                return profileSlug(this.currentUser.profile);
            },

            hasFilters() {
              return Object.values(this.donorSearch || {}).some(filtro => {
                return filtro != null && filtro != undefined && filtro != '';
              });
            }
        }, 

        methods: {
            async search() { 
               let unity = !this.showAllUnities
                    ? this.currentUser.unity_id
                    : (this.donorSearch.unity ?? null);
 

                sessionStorage.setItem('donorSearchFilter', JSON.stringify(this.donorSearch));
                const filters = { ...this.donorSearch };

                if(filters.rgct){
                  filters.rgct = filters.rgct.replace(/-/g, "");
                } 
                
                this.resource = await FormFieldsService.getPatientsData(filters, unity);
                this.$emit('resource', this.resource);
                this.loading = false;
                this.loadingBTN = false;
                this.menu = false;
            },

            clearFields() {
                this.donorSearch = { };
                sessionStorage.removeItem('donorSearchFilter');
                setTimeout(() => {
                    this.loadingTrashButton = false;
                    this.search(); 
                }, 1000);
            },
        },
    }
</script>

<style>
    .textBtn {
        font-family: "Poppins";
        color: #ffffff;
    }
</style>
